const SmallInputField = ({
  type = "text",
  label,
  name,
  value,
  onChange,
  placeholder,
  disabled = false,
}) => {
  const handleInputChange = (e) => {
    if (type === "number" && e.target.value < 0) return;
    onChange(e);
  };
  const handleWheel = (e) => {
    if (type === "number") {
      e.target.blur();
    }
  };

  return (
    <div className="my-auto">
      {label && (
        <label className="block text-sm font-medium text-text-secondary mb-2 ml-1 ">
          {label}
        </label>
      )}

      <input
        type={type}
        name={name}
        value={value || ""}
        onWheel={handleWheel}
        min={type === "number" ? 0 : undefined}
        onChange={handleInputChange}
        placeholder={placeholder}
        className={`w-full px-4 py-3 border border-border rounded-lg placeholder:px-0 placeholder:text-xs focus:outline-none focus:ring-1 focus:ring-primary text-sm
        ${
          type === "number"
            ? "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            : ""
        }`}
      />
    </div>
  );
};

export default SmallInputField;

// const SmallInputField = ({
//   type = "text",
//   label,
//   name,
//   value,
//   onChange,
//   placeholder,
// }) => {
//   return (
//     <div>
//       <label className="block text-sm font-medium text-text-secondary mb-2 ml-1">
//         {label}
//       </label>
//       <input
//         type={type}
//         name={name}
//         value={value || ""}
//         onChange={onChange}
//         min={type === "number" ? 0 : undefined}
//         placeholder={placeholder}
//         className="w-full px-4 py-3 border border-border rounded-lg placeholder:px-0 placeholder:text-xs focus:outline-none focus:ring-1 focus:ring-primary text-sm"
//       />
//     </div>
//   );
// };
// export default SmallInputField;
